<template>
    <div class="home">
        <div class="main">
          
        </div>
    </div>
</template>

<script>
    import {
       Dialog
    } from "vant";
    // import Header from "@/components/Header";
    export default {
        name: "ncic",
        /**
         * 初始化数据
         */
        data() {
          
            return {
               failinfo:this.$route.query.failinfo
            };
        },
        /**
         * 初始化
         */
        mounted() {
            this.pop()
        },
        /**
         * 方法
         */
        methods: {
          pop(){
            Dialog.alert({
            // title: '标题',
            message: this.failinfo,
          }).then(() => {
            // on close
            // alert(12345)
            // this.$tool.callModule("jumpHomePage",0);
          });
          }
          
        
        },
        components: {
            // Header,
          [ Dialog.name]: Dialog,
        }
    };
</script>

<style scoped lang="scss">
  
</style>